import { getProducts } from "@/api/products.service";

export const useProductSearch = () => {
  return {
    itemTitle: i => i.name,
    comparisonValue: v => v.id,

    fetchResults: (search, searchArgs) => {
      return getProducts({
        name: search,
        carrierId: searchArgs.carrierId,
        lines: searchArgs.lines,
        primaryProduct: searchArgs.primaryProduct
      });
    }
  };
};
